// eslint-disable-next-line
const jQuery = require('../../vendor/assets/jquery/jquery-1.7.1.min.js')
// @ts-ignore
window.$ = window.jQuery

// @ts-ignore
import Rails from '@rails/ujs'
// @ts-ignore
window.Rails = Rails
// @ts-ignore
Rails.start()

/* eslint-disable no-undef */
require('../../vendor/assets/bootstrap/bootstrap-carousel.js')
require('../../vendor/assets/bootstrap/bootstrap.min.js')
require('../../vendor/assets/jquery/jquery.easing.min.js')
require('../../vendor/assets/jquery/jquery.vgrid.min.js')
// eslint-enable no-undef */

import AjaxSetup from './models/jquery_ajax_setup'
import Block from './models/block'
import Message from './models/message'

AjaxSetup.setup()

// @ts-ignore
window.Block = Block
// @ts-ignore
window.Block.bindEvent()
// @ts-ignore
window.Message = Message
// @ts-ignore
window.Message.bind()
